import {useSearchParams} from "react-router";
import {useRef, useState} from "react";
import {useQuery} from "@tanstack/react-query";
import AttendanceInfoService from "../../../services/reports/attendance-info-service.jsx";
import {Template} from "../../../components/template/template.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import {Card} from "../../../components/card/card.jsx";
import Content from "./components/content.jsx";
import PrintOptionsModal from "../../../components/print-options-modal/print-options-modal.jsx";

const printFields = [
    {
        title: "Solicitantes",
        options: [
            {
                key: "showRequesters",
                label: "Exibir solicitantes na impressão",
            },
        ],
    },
    {
        title: "Anexos",
        options: [
            {
                key: "showImages",
                label: "Exibir imagens na impressão",
            },
            {
                key: "attachFullSize",
                label: "Imprimir um anexo por folha",
                disabled: (options) => !options.showImages,
            },
        ],
    },
];

const initialPrintOptions = Object.fromEntries(
    printFields.flatMap((group) =>
        group.options.map((item) => [item.key, false])
    )
);

export default function AttendanceInfo() {
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const [headerSelected, setHeaderSelected] = useState(-1);
    const [isPrinting, setIsPrinting] = useState(false);
    const [printModal, setPrintModal] = useState(false);
    const [printOptions, setPrintOptions] = useState(initialPrintOptions);
    const printComponentRef = useRef(null);
    const title = "Informações do atendimento";

    const { data: reportAttendance, isLoading: isLoadingReport } = useQuery({
        queryKey: ['report-attendance', id],
        queryFn: () => AttendanceInfoService.getAttendance(id),
        enabled: !!id,
    });

    const printItems = printFields;

    const hasData = !!reportAttendance?.attendance?.data?.attendance_id;

    return (
        <>
            <Template isLoading={isLoadingReport || isPrinting}>
                <Template.Header>
                    <Template.Title>{title}</Template.Title>
                    <HeaderButtons
                        printOptions={true}
                        printable={true}
                        setPrintModal={setPrintModal}
                        printComponentRef={printComponentRef}
                        reportData={reportAttendance}
                        data={hasData}
                        headerChange={true}
                        headerSelected={headerSelected}
                        setHeaderSelected={setHeaderSelected}
                    />
                </Template.Header>
                <Template.Body className="pl-0!">
                    <Card className="w-full max-w-[1030px] mx-auto p-[0]!">
                        <Card.Body>
                            <Content
                                id={id}
                                reportData={reportAttendance}
                                data={hasData}
                                entity={headerSelected}
                                title={title}
                                printComponentRef={printComponentRef}
                                setIsPrinting={setIsPrinting}
                                printOptions={printOptions}
                            />
                        </Card.Body>
                    </Card>
                </Template.Body>
            </Template>

            <PrintOptionsModal
                open={printModal}
                setOpen={setPrintModal}
                printRef={printComponentRef}
                options={printOptions}
                setOptions={setPrintOptions}
                items={printItems}
            />
        </>
    )
}